<template>
  <v-app>
    <div class="container" v-if="!authenticated">
      <router-view></router-view>
    </div>
    <v-navigation-drawer
      v-if="authenticated"
      persistent
      :mini-variant="miniVariant"
      v-model="drawer"
      :permanent="true"
      enable-resize-watcher
      :fixed="fixed"
      :width="barWidth"
      app
    >
      <v-list>
        <v-list-tile
          :value="false"
          ripple
          v-for="(item, i) in items"
          :key="i"
          :to="item.to"
        >
          <v-tooltip right :disabled="!miniVariant">
            <v-list-tile-action slot="activator">
              <v-icon v-html="item.icon"></v-icon>
            </v-list-tile-action>
            {{item.title}}
          </v-tooltip>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title">
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          :value="false"
          ripple
          v-for="(item, i) in itemsAdmin"
          :key="i"
          :to="item.to"
          v-if="admin"
        >
          <v-tooltip right :disabled="!miniVariant">
            <v-list-tile-action slot="activator">
              <v-icon v-html="item.icon"></v-icon>
            </v-list-tile-action>
            {{item.title}}
          </v-tooltip>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title">
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      v-if="authenticated"
      app
    > 
      <v-btn flat icon v-if="miniVariant" @click.stop="miniVariant = !miniVariant">
        <v-icon>chevron_right</v-icon>
      </v-btn> 
      <v-btn flat icon v-if="!miniVariant && barWidth==180" @click.stop="miniVariant = !miniVariant">
        <v-icon>chevron_left</v-icon>
      </v-btn> 
      <v-btn flat icon v-if="!miniVariant && barWidth==180" @click.stop="barWidth = 275">
        <v-icon>chevron_right</v-icon>
      </v-btn> 
      <v-btn flat icon v-if="barWidth==275" @click.stop="barWidth=180">
        <v-icon>chevron_left</v-icon>
      </v-btn> 
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click.stop="switchLanguage()">
          <v-icon>public</v-icon>
        </v-btn>
        <span>English/Français</span>
      </v-tooltip>
      
      <img v-if="! group==''" class="logo" :src="getLogoImage(group)" height="100%"/>

      <v-spacer></v-spacer>
      <button v-on:click='logout'> LOGOUT </button>

    </v-toolbar>
    <v-content>
      <v-slide-y-transition mode="out-in">
        <router-view/>
      </v-slide-y-transition>
    </v-content>
    <v-footer :fixed="fixed" app>
      <span>{{ $vuetify.t('$vuetify.app.footer') }}</span>
    </v-footer>
  </v-app>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'

export default {
  data () {
    return {
      authenticated: false,
      currentUser: {},
      group: '',
      admin: false,
      accessToken: '',
      barWidth: 180,
      drawer: true,
      fixed: true,
      logopath: '',
      generalGroups: ['ADMIN', 'EVERYONE'],
      rightsGroups: ['GlobalStats','DetailedStats', 'ExpertStats'],
      currentUser_RightsGroupsStringified: '',
      currentUser_RightsGroups: [],
      items: [
        {
          icon: 'dashboard',
          title: this.$vuetify.t('$vuetify.app.dashboard'),
          to: '/'
        },
        {
          icon: 'timer',
          title: this.$vuetify.t('$vuetify.app.time'),
          to: '/time'
        },
        {
          icon: 'shopping_cart',
          title: this.$vuetify.t('$vuetify.app.products'),
          to: '/products'
        }
      ],
      itemsAdmin: [
        {
          icon: 'settings_overscan',
          title: this.$vuetify.t('$vuetify.app.scenes'),
          to: '/scenes'
        },
        {
          icon: 'not_listed_location',
          title: this.$vuetify.t('$vuetify.app.survey'),
          to: '/survey'
        }
      ],
      miniVariant: (localStorage.miniVariant === 'true') || true,
      right: true,
      rightDrawer: false,
      title: this.$vuetify.t('$vuetify.app.title'),
      imageLink: './assets/logo',
      loggedIn: false
    }
  },
  async created () {
      this.isAuthenticated()
      this.accessToken = await this.$auth.getAccessToken()
      while(typeof(this.accessToken) == 'undefined'){
        this.accessToken = await this.$auth.getAccessToken()
      }
      axios.defaults.headers.common['Authorization'] = `Bearer ${this.accessToken}`
      const response = await axios.get(process.env.ISSUER_OKTA+'/v1/userinfo')
      this.currentUser = response.data
      for (let i in this.currentUser.groups){
        if (!this.generalGroups.includes(this.currentUser.groups[i]) && !this.rightsGroups.includes(this.currentUser.groups[i])){
            this.group = this.currentUser.groups[i]
        }
        if (this.currentUser.groups[i] == 'ADMIN'){
          this.admin = true
        }
        if (this.rightsGroups.includes(this.currentUser.groups[i])){
          this.currentUser_RightsGroups.push(this.currentUser.groups[i])
        }
      }
      this.currentUser_RightsGroupsStringified = JSON.stringify(this.currentUser_RightsGroups)   
  },
  watch: {
    miniVariant (value) {
      localStorage.miniVariant = value
    },
    '$route': 'isAuthenticated',
  },
  methods: {
    switchLanguage () {
      if (this.$vuetify.lang.current === 'langFr') {
        localStorage.lang = 'langEn'
      } else {
        localStorage.lang = 'langFr'
      }
      location.reload()
    },
    getLogoImage (clientPath) {
      return require('./assets/' + clientPath + '/logo.png')
    },
    async isAuthenticated () {
        this.authenticated = await this.$auth.isAuthenticated()
    },
    login () {
        this.$auth.loginRedirect('/')
    },
    async logout () {
        await this.$auth.logout()
        await this.isAuthenticated()

        // Navigate back to home
        this.$router.push({ path: '/' })
        location.reload()
    }
  },
  name: 'App'
}
</script>

<style scoped>
  .logo {
    margin: auto
  }
</style>




// WEBPACK FOOTER //
// src/App.vue